import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown, LogOut, User, Settings } from 'lucide-react';
import { getUser } from '../utils/helpers';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../utils/theme';

const UserProfileDropdown = ({ logout = () => { } }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);
    const { theme } = useTheme();
    const isDarkMode = true; // OLED: always dark
    const navigate = useNavigate();

    // Close dropdown when clicking outside
    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleProfile = () => {
        console.log('Opening profile...');
        setIsOpen(false);
    };

    const handleSettings = () => {
        console.log('Opening settings...');
        setIsOpen(false);
        navigate('/settings');
    };

    const getAvatarIcon = (name) => {
        if (name) {
            return name?.charAt(0).toUpperCase();
        } else {
            return 'G';
        }
    };

    return (
        <div className="relative" ref={dropdownRef}>
            {/* Profile Button */}
            <button
                onClick={() => setIsOpen(!isOpen)}
                className={`flex items-center gap-3 px-2 rounded-lg transition-colors duration-200 w-full ${
                    'hover:bg-gray-700'
                }`}
            >
                {/* Avatar */}
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center text-white font-semibold text-sm">
                    {getAvatarIcon(getUser()?.name)}
                </div>

                {/* User Info */}
                <div className="flex-1 text-left">
                    <div className={`font-semibold text-sm ${
                        'text-gray-100'
                    }`}>
                        {getUser()?.name}
                    </div>
                </div>

                {/* Chevron */}
                <ChevronDown
                    className={`w-4 h-4 transition-transform duration-200 ${
                        isOpen ? 'rotate-180' : ''
                    } ${
                        'text-gray-400'
                    }`}
                />
            </button>

            {/* Dropdown Menu */}
            {isOpen && (
                <div className={`absolute top-full left-0 right-0 mt-1 rounded-lg shadow-lg z-50 py-1 ${
                    'bg-gray-800 border border-gray-700'
                }`}>
                    <button
                        onClick={handleSettings}
                        className={`flex items-center gap-3 w-full px-4 py-2 text-sm transition-colors duration-150 ${
                            'text-gray-200 hover:bg-gray-700'
                        }`}
                    >
                        <Settings className="w-4 h-4" />
                        Settings
                    </button>

                    <hr className={`my-1 ${
                        'border-gray-600'
                    }`} />

                    <button
                        onClick={logout}
                        className={`flex items-center gap-3 w-full px-4 py-2 text-sm text-red-600 transition-colors duration-150 ${
                            'hover:bg-red-900/20'
                        }`}
                    >
                        <LogOut className="w-4 h-4" />
                        Logout
                    </button>
                </div>
            )}
        </div>
    );
};

export default UserProfileDropdown;